import React, { useEffect, useRef, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, Input } from 'components'
import Native from 'library/native'
import { useNavigate } from 'react-router-dom'

const CertImport = () => {

	const App = useApp()
	const navigate = useNavigate()
	const mounted = useRef()
	const [num, setNum] = useState([])
	const [buttonDisabled, setButtonDisabled] = useState(true)

	const [logger, setLogger] = useState()

	const getCertNumber = () => {
		Native.execute("Cert", "getCertAuthNum", (result) => {
			setLogger(JSON.stringify(result))
			const json = JSON.parse(result)
			setLogger(JSON.stringify(result))
			if (json.resultCode === "0") {
				const number = JSON.parse(result).result
				setLogger(JSON.stringify(number))
				setNum(number) 
			} else {
				App.alert(`${json.resultCode}: 인증번호 생성 도중에 오류가 발생했습니다.`)
			}

		}, {})
	}

	const getCertificate = () => {
		Native.execute("Cert", "getCertificate", (res) => {
			setLogger(JSON.stringify(res))
			const json = JSON.parse(res)
			let result = json.result
			if (typeof result === "string" && result.startsWith("%")) result = decodeURI(result)
			if (json.resultCode === "0") {
				console.log(result)
				App.alert("인증서 가져오기를 완료했습니다.", () => {
					navigate("/more/certificate")
				})
			} else {
				App.alert(result)
			}
		}, {})
	}

	useEffect(() => {
		if (num.length > 0) {
			setButtonDisabled(false)
		} else {
			setButtonDisabled(true)
		}
	}, [num])

	useEffect(() => {
		mounted.current = true
		App.setHeader({
			show: true,
			title: "인증서 가져오기",
			left: undefined,
			right: undefined
		})

		App.setShowNav(false)
		App.setMainClass("white")

		getCertNumber()

		return () => {
			mounted.current = false
		}

	}, [])

	return (
		<div className="page">
			<div className="padding flex_1">

				<div className="flex import-step">
					<div className="flex--item_1">
						<i className="icon_pc"></i>
						<p>PC</p>
					</div>
					<div className="flex--item_1">
						<i className="icon_mobile"></i>
						<p>스마트폰</p>
					</div>
				</div>
				<h4 className="mt_20">인증번호</h4>
				<div className="flex input-group mt_10">
					<Input placeholder="1234" style={{ flex: 1, width: 0, textAlign: "center" }} value={num[0]} readOnly />
					<span>-</span>
					<Input placeholder="" style={{ flex: 1, width: 0, textAlign: "center" }} value={num[1]} readOnly />
					<span>-</span>
					<Input placeholder="" style={{ flex: 1, width: 0, textAlign: "center" }} value={num[2]} readOnly />
				</div>
				<ul className="numberList py_30" style={{ fontSize: "1.4rem" }}>
					<li className="step01"><span className="numberList__number">1</span>{App.comName} 사이트에 접속합니다.</li>
					<li className="step02"><span className="numberList__number">2</span>인증센터에서 [인증서복사]를 선택합니다.</li>
					<li className="step03"><span className="numberList__number">3</span>사용할 인증서를 선택하고 비밀번호를 입력하세요.</li>
					<li><span className="numberList__number">4</span>인증번호 입력란에 인증번호를 입력하세요.</li>
				</ul>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big" disabled={buttonDisabled} onClick={getCertificate}>인증서 가져오기</Button>
			</div>
		</div>
	)
}


export default CertImport
